<template>
    <div class="pagination-wrap">
        <el-pagination ref="pagination" :hide-on-single-page="false" :pager-count="5" :page-size="paging.limit"
            :total="paging.total" :current-page="currentPage" background :layout="layout"
            @size-change="handleSizeChange" @current-change="handlePageChange">
        </el-pagination>
    </div>
    
</template>
<script>
export default {
    name: 'Pagination',
    props: {
        paging: {
            type: Object,
            default: () => {
                return {
                    total: 0,
                    offset: 0,
                    limit: 10
                }
            }
        },
        layout: {
            type: String,
            default: () => 'total, prev, pager, next, sizes, jumper'
        }
    },
    data() {
        return {}
    },
    computed: {
        currentPage: {
            get() {
                return parseInt(this.paging.offset / this.paging.limit) + 1
            },
            set(val) {
                this.$emit('update:page', val)
            }
        },
        tototPage: function() {
            return Math.ceil(this.paging.total / this.paging.limit);
        }
    },
    watch: {
    },
    methods: {
        // 监听每页多少条数据（limit）
        handleSizeChange(limit) {
            this.$emit('paginationChanged', { offset: this.currentPage - 1, limit: limit })
        },
        // 监听当前是第几页（page）
        handlePageChange(page) {
            this.$emit('paginationChanged', { offset: (page - 1), limit: this.paging.limit })
        }
    }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.pagination-wrap {
    @include adaptation(( 
        --cbaas-pagination-height: 36px,
        --cbaas-pagination-bottom: 24px,
        --cbaas-pagination-padding-right: 11px,
    ));

    width: 100%;
    height: var(--cbaas-pagination-height);
    position: absolute;
    bottom: var(--cbaas-pagination-bottom);
    padding-right: var(--cbaas-pagination-padding-right);
    display: flex;
    flex-direction: row-reverse;
}
</style>